var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSulphites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.28758 0.5H4.59648M8.34936 7.13617V0.5H5.5347V7.06755L0.802332 14.5041C0.245952 15.3784 0.503686 16.5382 1.378 17.0946C1.67907 17.2862 2.02854 17.388 2.38541 17.388H11.4864C12.5227 17.388 13.3628 16.5479 13.3628 15.5115C13.3628 15.1527 13.2599 14.8015 13.0664 14.4993L8.34936 7.13617ZM11.3048 11.7587H2.53239L0.791425 14.5075C0.236934 15.3831 0.497173 16.5423 1.37268 17.0968C1.67301 17.287 2.02119 17.388 2.37668 17.388H11.4833C12.5197 17.388 13.3598 16.5479 13.3598 15.5115C13.3598 15.1523 13.2566 14.8005 13.0626 14.4982L11.3048 11.7587Z",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSulphites);
export default __webpack_public_path__ + "static/media/sulphites.3df35924508bb45915e2700faa55efb6.svg";
export { ForwardRef as ReactComponent };